import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

export const styles = StyleSheet.create({
  page: {
    position: 'relative',
    paddingBottom: 40,
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 40,
    fontWeight: 900,
    marginTop: 10,
    textTransform: 'uppercase',
    width: '70%',
  },
  lineBar: {
    borderTop: '5px solid white',
    width: 130,
    marginTop: 20,
  },

  contentWrapper: {
    marginTop: 20,
    marginLeft: 53,
    marginRight: 53,
  },
  gridContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    gap: 10,
  },
  gridItem: {
    width: '31%',
    marginBottom: 20,
    fontFamily: 'Lato',
  },
  gridItemTitle: {
    fontSize: 9,
    fontWeight: 700,
    marginBottom: 4,
    color: 'black',
  },
  gridItemText: {
    fontSize: 9,
    color: 'black',
    lineHeight: 1.4,
  },

  boldText: {
    color: 'black',
    fontSize: 9,
    lineHeight: 1.5,
    fontFamily: 'Lato',
    fontWeight: 900,
    marginBottom: 2,
  },
  text: {
    color: 'black',
    fontSize: 9,
    lineHeight: 1.5,
    fontWeight: 'thin',
  },

  downloadThePartnerBrochureWrapper: {
    position: 'absolute',
    bottom: 60,
    left: 0,
    width: '100%',
    maxWidth: 600,
    height: 126,

    backgroundColor: 'black',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 6,
  },
  downloadImage: {
    position: 'absolute',
    objectFit: 'cover',
    width: '100%',
    maxWidth: 600,
    height: '126px',
  },
  downloadThePartnerBrochureTitle: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 24,
    fontWeight: 900,
  },
  downloadThePartnerBrochureText: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 16,
  },
  downloadThePartnerBrochureButtonWrapper: {
    marginTop: 10,
    width: 'auto',
  },

  downloadThePartnerBrochureButton: {
    border: '2px solid white',
    borderRadius: 3,
    cursor: 'pointer',
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 12,
    textDecoration: 'none',
    textAlign: 'center',

    paddingVertical: 4,
    paddingHorizontal: 8,
  },
});
